const roles = ["WORKER", "SUPERVISOR", "ACCOUNTANT", "ADMIN"];

export default roles;
